module.exports = __webpack_public_path__ + "img/encontro-especialista.b6f64cb0.svg";